import * as React from "react";

interface HtmlDivProps {
    html?: string | null;
    className?: string;
}

// This component is used to render HTML content in a div element
// Bypasses React's XSS protection
const HtmlDiv = ({ html, className }: HtmlDivProps) => {
    if (!html) {
        return null;
    }
    const getHtml = function () {
        return { __html: html };
    };

    return (
        <div className={className} dangerouslySetInnerHTML={getHtml()}>
        </div>
    );
};

export default HtmlDiv;
